// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Heading, Text } from '@locus-taxy/neo-ui';

import { JsonFormsDispatch } from '@jsonforms/react';
import { rankWith, uiTypeIs } from '@jsonforms/core';

import useLayoutProps from '../util/useLayoutProps';

type Props = {};

const containerProps = {
    padding: 4,
    borderWidth: 'thin',
    borderStyle: 'solid',
    borderColor: 'grey.300',
    borderRadius: '4px' // Right now no enum is there for this.
};

const GroupLayoutRenderer = (props: Props): React.Node => {
    const { t } = useTranslation('platform');
    const {
        uischema,
        schema,
        path,
        renderers,
        cells,
        enabled,
        visible
    } = useLayoutProps(props);

    return (
        visible && (
            <Box {...(uischema.options?.showBorder && containerProps)}>
                <Stack space="medium">
                    <Heading size="large" color="grey.900">
                        {t(uischema.label)}
                    </Heading>
                    {uischema.description ? (
                        <Text size="medium" fontWeight={400} color="grey.600">
                            {t(uischema.description)}
                        </Text>
                    ) : null}

                    {uischema.elements.map((element, index) => (
                        <JsonFormsDispatch
                            key={index}
                            uischema={element}
                            schema={schema}
                            path={path}
                            enabled={enabled}
                            renderers={renderers}
                            cells={cells}
                        />
                    ))}
                </Stack>
            </Box>
        )
    );
};

export default GroupLayoutRenderer;

export const groupLayoutTester = rankWith(1, uiTypeIs('Group'));
